import { useEffect, useState } from "react";
import styles from "./backtotop.module.css";
import 'remixicon/fonts/remixicon.css';

export default function BackToTop() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShow(window.scrollY > 100);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
 //▲^
  return (
    show && (
      <button onClick={scrollTop} className={styles.backTotop}>
     <i class="ri-arrow-up-s-line"></i> 
      </button>
    )
  );
}
